export default __webpack_public_path__ + "static/alock-aeb06ae0620f1cfef6e78577e22b774d.jpg";